import { render, staticRenderFns } from "./ReferralCheckList.vue?vue&type=template&id=9818226c&"
import script from "./ReferralCheckList.vue?vue&type=script&lang=js&"
export * from "./ReferralCheckList.vue?vue&type=script&lang=js&"
import style0 from "./ReferralCheckList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports